import * as AlertDialog from "@radix-ui/react-alert-dialog";

import { Button } from "@/components/kit";

/** Web equivalent of mobile's ConfirmSheet: focus-trapped, Esc closes. */
export function ConfirmDialog({ open, title, message, confirmLabel, onConfirm, onCancel, loading, testId }) {
  return (
    <AlertDialog.Root open={open} onOpenChange={(o) => !o && !loading && onCancel()}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-50 bg-[hsl(226_70%_4%/0.7)] backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <AlertDialog.Content data-testid={testId}
          className="fixed inset-x-0 bottom-0 z-50 rounded-t-3xl border border-border bg-card p-6 pb-8 shadow-2xl outline-none data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom-8 sm:inset-auto sm:left-1/2 sm:top-1/2 sm:w-full sm:max-w-md sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-3xl sm:pb-6 sm:data-[state=open]:zoom-in-95 sm:data-[state=open]:slide-in-from-bottom-0">
          <AlertDialog.Title className="text-xl font-medium text-foreground">{title}</AlertDialog.Title>
          <AlertDialog.Description className="mb-6 mt-2 text-base text-card-foreground">{message}</AlertDialog.Description>
          <div className="flex flex-col gap-2 sm:flex-row-reverse">
            <Button title={confirmLabel} variant="danger" onClick={onConfirm} loading={loading} className="sm:flex-1"
              data-testid={`${testId}-confirm`} />
            <AlertDialog.Cancel asChild>
              <Button title="Cancel" variant="ghost" className="sm:flex-1" data-testid={`${testId}-cancel`} />
            </AlertDialog.Cancel>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
